module.exports = require("@projectstorm/react-diagrams-core");